import normalizeEntity from 'normalized-redux/entity-normalizer';

// Temporary `virtual` entity
const normalizedGroupWorkspaces = normalizeEntity({ entity: 'groupWorkspace' });

export default normalizedGroupWorkspaces;
